import { resources } from "@constants/hardcoded-strings";
import {
    AXNUIContent
} from "@iddataweb/idw-common-ui/types";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { ThemingAsyncWaitingPageValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";

export const getThemingAsyncWaitingPageValidationErrors = (
    isUsingThemedUI: boolean,
    showIncodeFlowTabs: boolean,
    axnuiContent: AXNUIContent
): ThemingAsyncWaitingPageValidationErrors => {
    let count = 0;
    let continueInfoPhoneTextError = null;
    let detailTextError = null;
    let asyncSubmissionInProgressTextError = null;

    if (isUsingThemedUI && showIncodeFlowTabs) {
        if (!axnuiContent.common.asyncModal.continueInfoPhone) {
            count += 1;
            continueInfoPhoneTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.common.asyncModal.details) {
            count += 1;
            detailTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.common.asyncModal.waiting) {
            count += 1;
            asyncSubmissionInProgressTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
    }
    return {
        continueInfoPhoneTextError,
        detailTextError,
        asyncSubmissionInProgressTextError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.theming.subTabs.asyncWaitingPage.tabName}
            errorCount={count}
        />
    };
};